import { ILayoutElement } from "@faire/web-api/indigofair/data/ILayoutElement";
import { observer } from "mobx-react";
import React from "react";

import { useCategoryPageFilterKeys } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useCategoryPageQueryParams } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageQueryParams";
import { LoggedOutCategoryPageLayoutElementRenderer } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageLayoutElements/__internal__/LoggedOutCategoryPageLayoutElementRenderer";
import { useLoggedOutCategoryPageLayoutElementsResponse } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageLayoutElementsResponse";

interface IProps {
  placement: Array<keyof typeof ILayoutElement.Placement | undefined>;
}

const ELIGIBLE_SHOWROOM_BANNER_PAGE = 1;

const LoggedOutCategoryPageLayoutElementsBase: React.FC<IProps> = ({
  placement,
}) => {
  const filterKeys = useCategoryPageFilterKeys();
  const { data: layoutElementsData } =
    useLoggedOutCategoryPageLayoutElementsResponse(filterKeys);
  const { oneIndexedPageNumber } = useCategoryPageQueryParams();
  const layoutElements = layoutElementsData?.layout_elements;
  const requestId = layoutElementsData?.request_id;

  if (layoutElements === undefined) {
    return null;
  }

  const filteredLayoutElements = layoutElements.filter((layoutElement) =>
    new Set(placement).has(layoutElement.placement)
  );
  return (
    <>
      {filteredLayoutElements.map((layoutElement, index) => (
        <React.Fragment
          key={`logged-out-category-page-carousel-${layoutElement.type}-${index}`}
        >
          <LoggedOutCategoryPageLayoutElementRenderer
            layoutElement={layoutElement}
            requestId={requestId}
            shouldDisplayShowroomBanner={
              oneIndexedPageNumber === ELIGIBLE_SHOWROOM_BANNER_PAGE
            }
            placement={layoutElement.placement}
          />
        </React.Fragment>
      ))}
    </>
  );
};

export const LoggedOutCategoryPageLayoutElements = observer(
  LoggedOutCategoryPageLayoutElementsBase
);
